jQuery(document).ready(function ($) {
  $(".form_si").submit(function () {
    event.preventDefault();
    var site_key = $("meta[name='site_key']").attr("content");
    console.log(site_key);
    var form = $(this);
    grecaptcha.ready(function () {
      grecaptcha
        .execute(site_key, {
          action: "submit",
        })
        .then(function (token) {
          $('input[name="token"]').val(token);
          setTimeout(
            $.ajax({
              url: form.attr("action"),
              data: form.serialize(),
              type: form.attr("method"),
              dataType: "text",
              beforeSend: function (xhr) {
                form.find('button[type="submit"]').html("Proszę czekać...");
              },
              success: function (data) {
                form.find('button[type="submit"]').html(data);
              },
              error: function (data) {
                form
                  .find('button[type="submit"]')
                  .html("Błąd wysyłania. Spróbuj ponownie");
              },
            }),
            2000
          );
        });
    });
    return false;
  });
});
